const muiRoundedIcons: string[] = [
  'abc',
  'ac_unit',
  'access_alarm',
  'access_alarms',
  'access_time_filled',
  'access_time',
  'accessibility_new',
  'accessibility',
  'accessible_forward',
  'accessible',
  'account_balance',
  'account_balance_wallet',
  'account_box',
  'account_circle',
  'account_tree',
  'ad_units',
  'adb',
  'add_a_photo',
  'add_alarm',
  'add_alert',
  'add_box',
  'add_business',
  'add_card',
  'add_circle_outline',
  'add_circle',
  'add_comment',
  'add_home',
  'add_home_work',
  'add_ic_call',
  'add_link',
  'add_location_alt',
  'add_location',
  'add_moderator',
  'add_photo_alternate',
  'add_reaction',
  'add_road',
  'add',
  'add_shopping_cart',
  'add_task',
  'add_to_drive',
  'add_to_home_screen',
  'add_to_photos',
  'add_to_queue',
  'addchart',
  'adf_scanner',
  'adjust',
  'admin_panel_settings',
  'ads_click',
  'agriculture',
  'air',
  'airline_seat_flat_angled',
  'airline_seat_flat',
  'airline_seat_individual_suite',
  'airline_seat_legroom_extra',
  'airline_seat_legroom_normal',
  'airline_seat_legroom_reduced',
  'airline_seat_recline_extra',
  'airline_seat_recline_normal',
  'airline_stops',
  'airlines',
  'airplane_ticket',
  'airplanemode_active',
  'airplanemode_inactive',
  'airplay',
  'airport_shuttle',
  'alarm_add',
  'alarm_off',
  'alarm_on',
  'alarm',
  'album',
  'align_horizontal_center',
  'align_horizontal_left',
  'align_horizontal_right',
  'align_vertical_bottom',
  'align_vertical_center',
  'align_vertical_top',
  'all_inbox',
  'all_inclusive',
  'all_out',
  'alt_route',
  'alternate_email',
  'analytics',
  'anchor',
  'android',
  'animation',
  'announcement',
  'aod',
  'apartment',
  'api',
  'app_blocking',
  'app_registration',
  'app_settings_alt',
  'app_shortcut',
  'approval',
  'apps_outage',
  'apps',
  'architecture',
  'archive',
  'arrow_back_ios_new',
  'arrow_back_ios',
  'arrow_back',
  'arrow_circle_down',
  'arrow_circle_left',
  'arrow_circle_right',
  'arrow_circle_up',
  'arrow_downward',
  'arrow_drop_down_circle',
  'arrow_drop_down',
  'arrow_drop_up',
  'arrow_forward_ios',
  'arrow_forward',
  'arrow_left',
  'arrow_outward',
  'arrow_right_alt',
  'arrow_right',
  'arrow_upward',
  'art_track',
  'article',
  'aspect_ratio',
  'assessment',
  'assignment_ind',
  'assignment_late',
  'assignment_return',
  'assignment_returned',
  'assignment',
  'assignment_turned_in',
  'assist_walker',
  'assistant_direction',
  'assistant_photo',
  'assistant',
  'assured_workload',
  'atm',
  'attach_email',
  'attach_file',
  'attach_money',
  'attachment',
  'attractions',
  'attribution',
  'audio_file',
  'audiotrack',
  'auto_awesome_mosaic',
  'auto_awesome_motion',
  'auto_awesome',
  'auto_delete',
  'auto_fix_high',
  'auto_fix_normal',
  'auto_fix_off',
  'auto_graph',
  'auto_mode',
  'auto_stories',
  'autofps_select',
  'autorenew',
  'av_timer',
  'baby_changing_station',
  'back_hand',
  'backpack',
  'backspace',
  'backup',
  'backup_table',
  'badge',
  'bakery_dining',
  'balance',
  'balcony',
  'ballot',
  'bar_chart',
  'batch_prediction',
  'bathroom',
  'bathtub',
  'battery_0_bar',
  'battery_1_bar',
  'battery_2_bar',
  'battery_3_bar',
  'battery_4_bar',
  'battery_5_bar',
  'battery_6_bar',
  'battery_alert',
  'battery_charging_full',
  'battery_full',
  'battery_saver',
  'battery_std',
  'battery_unknown',
  'beach_access',
  'bed',
  'bedroom_baby',
  'bedroom_child',
  'bedroom_parent',
  'bedtime_off',
  'bedtime',
  'beenhere',
  'bento',
  'bike_scooter',
  'biotech',
  'blender',
  'blind',
  'blinds_closed',
  'blinds',
  'block',
  'bloodtype',
  'bluetooth_audio',
  'bluetooth_connected',
  'bluetooth_disabled',
  'bluetooth_drive',
  'bluetooth',
  'bluetooth_searching',
  'blur_circular',
  'blur_linear',
  'blur_off',
  'blur_on',
  'bolt',
  'book_online',
  'book',
  'bookmark_add',
  'bookmark_added',
  'bookmark_border',
  'bookmark_remove',
  'bookmark',
  'bookmarks',
  'border_all',
  'border_bottom',
  'border_clear',
  'border_color',
  'border_horizontal',
  'border_inner',
  'border_left',
  'border_outer',
  'border_right',
  'border_style',
  'border_top',
  'border_vertical',
  'boy',
  'branding_watermark',
  'breakfast_dining',
  'brightness_1',
  'brightness_2',
  'brightness_3',
  'brightness_4',
  'brightness_5',
  'brightness_6',
  'brightness_7',
  'brightness_auto',
  'brightness_high',
  'brightness_low',
  'brightness_medium',
  'broadcast_on_home',
  'broadcast_on_personal',
  'broken_image',
  'browse_gallery',
  'browser_not_supported',
  'browser_updated',
  'brunch_dining',
  'brush',
  'bubble_chart',
  'bug_report',
  'build_circle',
  'build',
  'bungalow',
  'burst_mode',
  'bus_alert',
  'business_center',
  'business',
  'cabin',
  'cable',
  'cached',
  'cake',
  'calculate',
  'calendar_month',
  'calendar_today',
  'calendar_view_day',
  'calendar_view_month',
  'calendar_view_week',
  'call_end',
  'call_made',
  'call_merge',
  'call_missed_outgoing',
  'call_missed',
  'call_received',
  'call',
  'call_split',
  'call_to_action',
  'camera_alt',
  'camera_enhance',
  'camera_front',
  'camera_indoor',
  'camera_outdoor',
  'camera_rear',
  'camera_roll',
  'camera',
  'cameraswitch',
  'campaign',
  'cancel_presentation',
  'cancel',
  'cancel_schedule_send',
  'candlestick_chart',
  'car_crash',
  'car_rental',
  'car_repair',
  'card_giftcard',
  'card_membership',
  'card_travel',
  'carpenter',
  'cases',
  'casino',
  'cast_connected',
  'cast_for_education',
  'cast',
  'castle',
  'catching_pokemon',
  'category',
  'celebration',
  'cell_tower',
  'cell_wifi',
  'center_focus_strong',
  'center_focus_weak',
  'chair_alt',
  'chair',
  'chalet',
  'change_circle',
  'change_history',
  'charging_station',
  'chat_bubble_outline',
  'chat_bubble',
  'chat',
  'check_box_outline_blank',
  'check_box',
  'check_circle_outline',
  'check_circle',
  'check',
  'checklist',
  'checklist_rtl',
  'checkroom',
  'chevron_left',
  'chevron_right',
  'child_care',
  'child_friendly',
  'chrome_reader_mode',
  'church',
  'circle_notifications',
  'circle',
  'class',
  'clean_hands',
  'cleaning_services',
  'clear_all',
  'clear',
  'close_fullscreen',
  'close',
  'closed_caption_disabled',
  'closed_caption_off',
  'closed_caption',
  'cloud_circle',
  'cloud_done',
  'cloud_download',
  'cloud_off',
  'cloud_queue',
  'cloud',
  'cloud_sync',
  'cloud_upload',
  'co_2',
  'co_present',
  'code_off',
  'code',
  'coffee_maker',
  'coffee',
  'collections_bookmark',
  'collections',
  'color_lens',
  'colorize',
  'comment_bank',
  'comment',
  'comments_disabled',
  'commit',
  'commute',
  'compare_arrows',
  'compare',
  'compass_calibration',
  'compress',
  'computer',
  'confirmation_number',
  'connect_without_contact',
  'connected_tv',
  'connecting_airports',
  'construction',
  'contact_emergency',
  'contact_mail',
  'contact_page',
  'contact_phone',
  'contact_support',
  'contactless',
  'contacts',
  'content_copy',
  'content_cut',
  'content_paste_go',
  'content_paste_off',
  'content_paste',
  'content_paste_search',
  'contrast',
  'control_camera',
  'control_point_duplicate',
  'control_point',
  'cookie',
  'copy_all',
  'copyright',
  'coronavirus',
  'corporate_fare',
  'cottage',
  'countertops',
  'create_new_folder',
  'create',
  'credit_card_off',
  'credit_card',
  'credit_score',
  'crib',
  'crisis_alert',
  'crop_din',
  'crop_free',
  'crop_landscape',
  'crop_original',
  'crop_portrait',
  'crop_rotate',
  'crop',
  'crop_square',
  'css',
  'currency_bitcoin',
  'currency_exchange',
  'currency_franc',
  'currency_lira',
  'currency_pound',
  'currency_ruble',
  'currency_rupee',
  'currency_yen',
  'currency_yuan',
  'curtains_closed',
  'curtains',
  'cyclone',
  'dangerous',
  'dark_mode',
  'dashboard_customize',
  'dashboard',
  'data_array',
  'data_object',
  'data_saver_off',
  'data_saver_on',
  'data_thresholding',
  'data_usage',
  'dataset_linked',
  'dataset',
  'date_range',
  'deblur',
  'deck',
  'dehaze',
  'delete_forever',
  'delete_outline',
  'delete',
  'delete_sweep',
  'delivery_dining',
  'density_large',
  'density_medium',
  'density_small',
  'departure_board',
  'description',
  'deselect',
  'design_services',
  'desk',
  'desktop_access_disabled',
  'desktop_mac',
  'desktop_windows',
  'details',
  'developer_board_off',
  'developer_board',
  'developer_mode',
  'device_hub',
  'device_thermostat',
  'device_unknown',
  'devices_fold',
  'devices_other',
  'devices',
  'dialer_sip',
  'dialpad',
  'diamond',
  'difference',
  'dining',
  'dinner_dining',
  'directions_bike',
  'directions_boat_filled',
  'directions_boat',
  'directions_bus_filled',
  'directions_bus',
  'directions_car_filled',
  'directions_car',
  'directions_off',
  'directions_railway_filled',
  'directions_railway',
  'directions',
  'directions_run',
  'directions_subway_filled',
  'directions_subway',
  'directions_transit_filled',
  'directions_transit',
  'directions_walk',
  'dirty_lens',
  'disabled_by_default',
  'disc_full',
  'discount',
  'display_settings',
  'diversity_1',
  'diversity_2',
  'diversity_3',
  'dns',
  'do_disturb_alt',
  'do_disturb_off',
  'do_disturb_on',
  'do_disturb',
  'do_not_disturb_alt',
  'do_not_disturb_off',
  'do_not_disturb_on',
  'do_not_disturb_on_total_silence',
  'do_not_disturb',
  'do_not_step',
  'do_not_touch',
  'dock',
  'document_scanner',
  'domain_add',
  'domain_disabled',
  'domain',
  'domain_verification',
  'done_all',
  'done_outline',
  'done',
  'donut_large',
  'donut_small',
  'door_back',
  'door_front',
  'door_sliding',
  'doorbell',
  'double_arrow',
  'downhill_skiing',
  'download_done',
  'download_for_offline',
  'download',
  'downloading',
  'drafts',
  'drag_handle',
  'drag_indicator',
  'draw',
  'drive_eta',
  'drive_file_move',
  'drive_file_rename_outline',
  'drive_folder_upload',
  'dry_cleaning',
  'dry',
  'duo',
  'dvr',
  'dynamic_feed',
  'dynamic_form',
  'e_mobiledata',
  'earbuds_battery',
  'earbuds',
  'east',
  'edgesensor_high',
  'edgesensor_low',
  'edit_attributes',
  'edit_calendar',
  'edit_location_alt',
  'edit_location',
  'edit_note',
  'edit_notifications',
  'edit_off',
  'edit_road',
  'edit',
  'egg_alt',
  'egg',
  '8k_plus',
  '8k',
  'eject',
  'elderly',
  'elderly_woman',
  'electric_bike',
  'electric_bolt',
  'electric_car',
  'electric_meter',
  'electric_moped',
  'electric_rickshaw',
  'electric_scooter',
  'electrical_services',
  'elevator',
  'email',
  'emergency_recording',
  'emergency_share',
  'emoji_emotions',
  'emoji_events',
  'emoji_flags',
  'emoji_food_beverage',
  'emoji_nature',
  'emoji_objects',
  'emoji_people',
  'emoji_symbols',
  'emoji_transportation',
  'energy_savings_leaf',
  'engineering',
  'enhanced_encryption',
  'equalizer',
  'error_outline',
  'error',
  'escalator',
  'escalator_warning',
  'euro',
  'euro_symbol',
  'ev_station',
  'event_available',
  'event_busy',
  'event_note',
  'event_repeat',
  'event',
  'event_seat',
  'exit_to_app',
  'expand_circle_down',
  'expand_less',
  'expand_more',
  'expand',
  'explicit',
  'explore_off',
  'explore',
  'exposure',
  'extension_off',
  'extension',
  'face_2',
  'face_3',
  'face_4',
  'face_5',
  'face_6',
  'face_retouching_natural',
  'face_retouching_off',
  'face',
  'facebook',
  'fact_check',
  'factory',
  'family_restroom',
  'fast_forward',
  'fast_rewind',
  'fastfood',
  'favorite_border',
  'favorite',
  'fax',
  'featured_play_list',
  'featured_video',
  'feed',
  'feedback',
  'female',
  'fence',
  'festival',
  'fiber_dvr',
  'fiber_manual_record',
  'fiber_new',
  'fiber_pin',
  'fiber_smart_record',
  'file_copy',
  'file_download_done',
  'file_download_off',
  'file_download',
  'file_open',
  'file_present',
  'file_upload',
  'filter_1',
  'filter_2',
  'filter_3',
  'filter_4',
  'filter_5',
  'filter_6',
  'filter_7',
  'filter_8',
  'filter_9_plus',
  'filter_9',
  'filter_alt_off',
  'filter_alt',
  'filter_b_and_w',
  'filter_center_focus',
  'filter_drama',
  'filter_frames',
  'filter_hdr',
  'filter_list_off',
  'filter_list',
  'filter_none',
  'filter',
  'filter_tilt_shift',
  'filter_vintage',
  'find_in_page',
  'find_replace',
  'fingerprint',
  'fire_extinguisher',
  'fire_hydrant_alt',
  'fire_truck',
  'fireplace',
  'first_page',
  'fit_screen',
  'fitbit',
  'fitness_center',
  '5g',
  '5k_plus',
  '5k',
  'flag_circle',
  'flag',
  'flaky',
  'flare',
  'flash_auto',
  'flash_off',
  'flash_on',
  'flashlight_off',
  'flashlight_on',
  'flatware',
  'flight_class',
  'flight_land',
  'flight',
  'flight_takeoff',
  'flip_camera_android',
  'flip_camera_ios',
  'flip',
  'flip_to_back',
  'flip_to_front',
  'flood',
  'fluorescent',
  'flutter_dash',
  'fmd_bad',
  'fmd_good',
  'folder_copy',
  'folder_delete',
  'folder_off',
  'folder_open',
  'folder',
  'folder_shared',
  'folder_special',
  'folder_zip',
  'follow_the_signs',
  'font_download_off',
  'font_download',
  'food_bank',
  'forest',
  'fork_left',
  'fork_right',
  'format_align_center',
  'format_align_justify',
  'format_align_left',
  'format_align_right',
  'format_bold',
  'format_clear',
  'format_color_fill',
  'format_color_reset',
  'format_color_text',
  'format_indent_decrease',
  'format_indent_increase',
  'format_italic',
  'format_line_spacing',
  'format_list_bulleted',
  'format_list_numbered',
  'format_list_numbered_rtl',
  'format_overline',
  'format_paint',
  'format_quote',
  'format_shapes',
  'format_size',
  'format_strikethrough',
  'format_textdirection_l_to_r',
  'format_textdirection_r_to_l',
  'format_underlined',
  'fort',
  'forum',
  'forward_10',
  'forward_30',
  'forward_5',
  'forward',
  'forward_to_inbox',
  'foundation',
  '4g_mobiledata',
  '4g_plus_mobiledata',
  '4k_plus',
  '4k',
  'free_breakfast',
  'fullscreen_exit',
  'fullscreen',
  'functions',
  'g_mobiledata',
  'g_translate',
  'gamepad',
  'games',
  'garage',
  'gas_meter',
  'gavel',
  'gesture',
  'get_app',
  'gif_box',
  'gif',
  'girl',
  'gite',
  'golf_course',
  'gpp_bad',
  'gpp_good',
  'gpp_maybe',
  'gps_fixed',
  'gps_not_fixed',
  'gps_off',
  'grade',
  'gradient',
  'grading',
  'grain',
  'graphic_eq',
  'grass',
  'grid_3x3',
  'grid_4x4',
  'grid_goldenratio',
  'grid_off',
  'grid_on',
  'grid_view',
  'group_add',
  'group_remove',
  'group',
  'group_work',
  'groups_2',
  'groups_3',
  'groups',
  'h_mobiledata',
  'h_plus_mobiledata',
  'hail',
  'handshake',
  'handyman',
  'hardware',
  'hd',
  'hdr_auto',
  'hdr_auto_select',
  'hdr_enhanced_select',
  'hdr_off',
  'hdr_off_select',
  'hdr_on',
  'hdr_on_select',
  'hdr_plus',
  'hdr_strong',
  'hdr_weak',
  'headphones_battery',
  'headphones',
  'headset_mic',
  'headset_off',
  'headset',
  'healing',
  'health_and_safety',
  'hearing_disabled',
  'hearing',
  'heart_broken',
  'heat_pump',
  'height',
  'help_center',
  'help_outline',
  'help',
  'hevc',
  'hexagon',
  'hide_image',
  'hide_source',
  'high_quality',
  'highlight_alt',
  'highlight_off',
  'highlight',
  'hiking',
  'history_edu',
  'history',
  'history_toggle_off',
  'hive',
  'hls_off',
  'hls',
  'holiday_village',
  'home_max',
  'home_mini',
  'home_repair_service',
  'home',
  'home_work',
  'horizontal_rule',
  'horizontal_split',
  'hot_tub',
  'hotel',
  'hourglass_bottom',
  'hourglass_disabled',
  'hourglass_empty',
  'hourglass_full',
  'hourglass_top',
  'house',
  'house_siding',
  'houseboat',
  'how_to_reg',
  'how_to_vote',
  'html',
  'http',
  'https',
  'hub',
  'hvac',
  'ice_skating',
  'icecream',
  'image_aspect_ratio',
  'image_not_supported',
  'image',
  'image_search',
  'imagesearch_roller',
  'import_contacts',
  'import_export',
  'important_devices',
  'inbox',
  'indeterminate_check_box',
  'info',
  'input',
  'insert_chart',
  'insert_comment',
  'insert_drive_file',
  'insert_emoticon',
  'insert_invitation',
  'insert_link',
  'insert_page_break',
  'insert_photo',
  'insights',
  'install_desktop',
  'install_mobile',
  'integration_instructions',
  'interests',
  'interpreter_mode',
  'inventory_2',
  'inventory',
  'invert_colors_off',
  'invert_colors',
  'ios_share',
  'iron',
  'iso',
  'javascript',
  'join_full',
  'join_inner',
  'join_left',
  'join_right',
  'kayaking',
  'kebab_dining',
  'key_off',
  'key',
  'keyboard_alt',
  'keyboard_arrow_down',
  'keyboard_arrow_left',
  'keyboard_arrow_right',
  'keyboard_arrow_up',
  'keyboard_backspace',
  'keyboard_capslock',
  'keyboard_command_key',
  'keyboard_control_key',
  'keyboard_double_arrow_down',
  'keyboard_double_arrow_left',
  'keyboard_double_arrow_right',
  'keyboard_double_arrow_up',
  'keyboard_hide',
  'keyboard_option_key',
  'keyboard_return',
  'keyboard',
  'keyboard_tab',
  'keyboard_voice',
  'king_bed',
  'kitchen',
  'kitesurfing',
  'label_important',
  'label_off',
  'label',
  'lan',
  'landscape',
  'landslide',
  'language',
  'laptop_chromebook',
  'laptop_mac',
  'laptop',
  'laptop_windows',
  'last_page',
  'launch',
  'layers_clear',
  'layers',
  'leaderboard',
  'leak_add',
  'leak_remove',
  'legend_toggle',
  'lens_blur',
  'lens',
  'library_add_check',
  'library_add',
  'library_books',
  'library_music',
  'light_mode',
  'light',
  'lightbulb_circle',
  'lightbulb',
  'line_axis',
  'line_style',
  'line_weight',
  'linear_scale',
  'link_off',
  'link',
  'linked_camera',
  'liquor',
  'list_alt',
  'list',
  'live_help',
  'live_tv',
  'living',
  'local_activity',
  'local_airport',
  'local_atm',
  'local_bar',
  'local_cafe',
  'local_car_wash',
  'local_convenience_store',
  'local_dining',
  'local_drink',
  'local_fire_department',
  'local_florist',
  'local_gas_station',
  'local_grocery_store',
  'local_hospital',
  'local_hotel',
  'local_laundry_service',
  'local_library',
  'local_mall',
  'local_movies',
  'local_offer',
  'local_parking',
  'local_pharmacy',
  'local_phone',
  'local_pizza',
  'local_play',
  'local_police',
  'local_post_office',
  'local_printshop',
  'local_see',
  'local_shipping',
  'local_taxi',
  'location_city',
  'location_disabled',
  'location_off',
  'location_on',
  'location_searching',
  'lock_clock',
  'lock_open',
  'lock_person',
  'lock_reset',
  'lock',
  'login',
  'logo_dev',
  'logout',
  'looks_3',
  'looks_4',
  'looks_5',
  'looks_6',
  'looks_one',
  'looks',
  'looks_two',
  'loop',
  'loupe',
  'low_priority',
  'loyalty',
  'lte_mobiledata',
  'lte_plus_mobiledata',
  'luggage',
  'lunch_dining',
  'lyrics',
  'macro_off',
  'mail_lock',
  'mail_outline',
  'mail',
  'male',
  'man_2',
  'man_3',
  'man_4',
  'man',
  'manage_accounts',
  'manage_history',
  'manage_search',
  'map',
  'maps_home_work',
  'maps_ugc',
  'margin',
  'mark_as_unread',
  'mark_chat_read',
  'mark_chat_unread',
  'mark_email_read',
  'mark_email_unread',
  'mark_unread_chat_alt',
  'markunread_mailbox',
  'markunread',
  'masks',
  'maximize',
  'media_bluetooth_off',
  'media_bluetooth_on',
  'mediation',
  'medical_information',
  'medical_services',
  'medication_liquid',
  'medication',
  'meeting_room',
  'memory',
  'menu_book',
  'menu_open',
  'menu',
  'merge',
  'merge_type',
  'message',
  'mic_external_off',
  'mic_external_on',
  'mic_none',
  'mic_off',
  'mic',
  'microwave',
  'military_tech',
  'minimize',
  'minor_crash',
  'miscellaneous_services',
  'missed_video_call',
  'mms',
  'mobile_friendly',
  'mobile_off',
  'mobile_screen_share',
  'mobiledata_off',
  'mode_comment',
  'mode_edit_outline',
  'mode_edit',
  'mode_fan_off',
  'mode_night',
  'mode_of_travel',
  'mode',
  'mode_standby',
  'model_training',
  'monetization_on',
  'money_off_csred',
  'money_off',
  'money',
  'monitor_heart',
  'monitor',
  'monitor_weight',
  'monochrome_photos',
  'mood_bad',
  'mood',
  'moped',
  'more_horiz',
  'more',
  'more_time',
  'more_vert',
  'mosque',
  'motion_photos_auto',
  'motion_photos_off',
  'mouse',
  'move_down',
  'move_to_inbox',
  'move_up',
  'movie_creation',
  'movie_filter',
  'movie',
  'moving',
  'mp',
  'multiline_chart',
  'multiple_stop',
  'museum',
  'music_note',
  'music_off',
  'music_video',
  'my_location',
  'nat',
  'nature_people',
  'nature',
  'navigate_before',
  'navigate_next',
  'navigation',
  'near_me_disabled',
  'near_me',
  'nearby_error',
  'nearby_off',
  'nest_cam_wired_stand',
  'network_cell',
  'network_check',
  'network_locked',
  'network_ping',
  'network_wifi_1_bar',
  'network_wifi_2_bar',
  'network_wifi_3_bar',
  'network_wifi',
  'new_releases',
  'newspaper',
  'next_plan',
  'next_week',
  'nfc',
  'night_shelter',
  'nightlife',
  'nightlight_round',
  'nightlight',
  'nights_stay',
  '9k_plus',
  '9k',
  'no_accounts',
  'no_adult_content',
  'no_backpack',
  'no_cell',
  'no_crash',
  'no_drinks',
  'no_encryption_gmailerrorred',
  'no_encryption',
  'no_flash',
  'no_food',
  'no_luggage',
  'no_meals',
  'no_meeting_room',
  'no_photography',
  'no_sim',
  'no_stroller',
  'no_transfer',
  'noise_aware',
  'noise_control_off',
  'nordic_walking',
  'north_east',
  'north',
  'north_west',
  'not_accessible',
  'not_interested',
  'not_listed_location',
  'not_started',
  'note_add',
  'note_alt',
  'note',
  'notes',
  'notification_add',
  'notification_important',
  'notifications_active',
  'notifications_none',
  'notifications_off',
  'notifications_paused',
  'notifications',
  'numbers',
  'offline_bolt',
  'offline_pin',
  'offline_share',
  'oil_barrel',
  'on_device_training',
  'ondemand_video',
  '1k_plus',
  '1k',
  'online_prediction',
  'opacity',
  'open_in_browser',
  'open_in_full',
  'open_in_new_off',
  'open_in_new',
  'open_with',
  'other_houses',
  'outbound',
  'outbox',
  'outdoor_grill',
  'outlet',
  'output',
  'padding',
  'pages',
  'pageview',
  'paid',
  'palette',
  'pan_tool_alt',
  'pan_tool',
  'panorama_fish_eye',
  'panorama_horizontal',
  'panorama_horizontal_select',
  'panorama_photosphere',
  'panorama_photosphere_select',
  'panorama',
  'panorama_vertical',
  'panorama_vertical_select',
  'panorama_wide_angle',
  'panorama_wide_angle_select',
  'paragliding',
  'park',
  'party_mode',
  'password',
  'pattern',
  'pause_circle_filled',
  'pause_circle_outline',
  'pause_circle',
  'pause_presentation',
  'pause',
  'payment',
  'payments',
  'pedal_bike',
  'pending_actions',
  'pending',
  'pentagon',
  'people_alt',
  'people_outline',
  'people',
  'percent',
  'perm_camera_mic',
  'perm_contact_calendar',
  'perm_data_setting',
  'perm_device_information',
  'perm_identity',
  'perm_media',
  'perm_phone_msg',
  'perm_scan_wifi',
  'person_2',
  'person_3',
  'person_4',
  'person_add_alt_1',
  'person_add_alt',
  'person_add_disabled',
  'person_add',
  'person_off',
  'person_outline',
  'person_pin_circle',
  'person_pin',
  'person_remove_alt_1',
  'person_remove',
  'person',
  'person_search',
  'personal_video',
  'pest_control_rodent',
  'pest_control',
  'pets',
  'phishing',
  'phone_android',
  'phone_bluetooth_speaker',
  'phone_callback',
  'phone_disabled',
  'phone_enabled',
  'phone_forwarded',
  'phone_in_talk',
  'phone_iphone',
  'phone_locked',
  'phone_missed',
  'phone_paused',
  'phone',
  'phonelink_erase',
  'phonelink_lock',
  'phonelink_off',
  'phonelink_ring',
  'phonelink',
  'phonelink_setup',
  'photo_album',
  'photo_camera_back',
  'photo_camera_front',
  'photo_camera',
  'photo_filter',
  'photo_library',
  'photo',
  'photo_size_select_actual',
  'photo_size_select_large',
  'photo_size_select_small',
  'php',
  'piano_off',
  'piano',
  'picture_as_pdf',
  'picture_in_picture_alt',
  'picture_in_picture',
  'pie_chart_outline',
  'pie_chart',
  'pin_drop',
  'pin',
  'pinch',
  'pivot_table_chart',
  'pix',
  'place',
  'plagiarism',
  'play_arrow',
  'play_circle_filled',
  'play_circle_outline',
  'play_circle',
  'play_disabled',
  'play_for_work',
  'play_lesson',
  'playlist_add_check_circle',
  'playlist_add_check',
  'playlist_add_circle',
  'playlist_add',
  'playlist_play',
  'playlist_remove',
  'plumbing',
  'plus_one',
  'podcasts',
  'point_of_sale',
  'policy',
  'poll',
  'polyline',
  'pool',
  'portable_wifi_off',
  'portrait',
  'post_add',
  'power_input',
  'power_off',
  'power',
  'power_settings_new',
  'precision_manufacturing',
  'pregnant_woman',
  'present_to_all',
  'preview',
  'price_change',
  'price_check',
  'print_disabled',
  'print',
  'priority_high',
  'privacy_tip',
  'production_quantity_limits',
  'propane',
  'propane_tank',
  'psychology_alt',
  'psychology',
  'public_off',
  'public',
  'publish',
  'published_with_changes',
  'punch_clock',
  'push_pin',
  'qr_code_2',
  'qr_code',
  'qr_code_scanner',
  'query_builder',
  'query_stats',
  'question_answer',
  'question_mark',
  'queue_music',
  'queue_play_next',
  'queue',
  'quickreply',
  'quiz',
  'r_mobiledata',
  'radar',
  'radio_button_checked',
  'radio_button_unchecked',
  'radio',
  'railway_alert',
  'ramen_dining',
  'ramp_left',
  'ramp_right',
  'rate_review',
  'raw_off',
  'raw_on',
  'read_more',
  'receipt_long',
  'receipt',
  'recent_actors',
  'recommend',
  'record_voice_over',
  'rectangle',
  'recycling',
  'redeem',
  'redo',
  'reduce_capacity',
  'refresh',
  'remember_me',
  'remove_circle_outline',
  'remove_circle',
  'remove_done',
  'remove_from_queue',
  'remove_moderator',
  'remove_red_eye',
  'remove_road',
  'remove',
  'remove_shopping_cart',
  'reorder',
  'repartition',
  'repeat_on',
  'repeat_one_on',
  'repeat_one',
  'repeat',
  'replay_10',
  'replay_30',
  'replay_5',
  'replay_circle_filled',
  'replay',
  'reply_all',
  'reply',
  'report_gmailerrorred',
  'report_off',
  'report_problem',
  'report',
  'request_page',
  'request_quote',
  'reset_tv',
  'restart_alt',
  'restaurant_menu',
  'restaurant',
  'restore_from_trash',
  'restore_page',
  'restore',
  'reviews',
  'rice_bowl',
  'ring_volume',
  'rocket_launch',
  'rocket',
  'roller_shades_closed',
  'roller_shades',
  'roller_skating',
  'roofing',
  'room_preferences',
  'room',
  'room_service',
  'rotate_90_degrees_ccw',
  'rotate_90_degrees_cw',
  'rotate_left',
  'rotate_right',
  'roundabout_left',
  'roundabout_right',
  'rounded_corner',
  'route',
  'router',
  'rowing',
  'rss_feed',
  'rsvp',
  'rtt',
  'rule_folder',
  'rule',
  'run_circle',
  'running_with_errors',
  'rv_hookup',
  'safety_check',
  'safety_divider',
  'sailing',
  'sanitizer',
  'satellite_alt',
  'satellite',
  'save_alt',
  'save_as',
  'save',
  'saved_search',
  'savings',
  'scale',
  'scanner',
  'scatter_plot',
  'schedule',
  'schedule_send',
  'schema',
  'school',
  'science',
  'score',
  'scoreboard',
  'screen_lock_landscape',
  'screen_lock_portrait',
  'screen_lock_rotation',
  'screen_rotation_alt',
  'screen_rotation',
  'screen_search_desktop',
  'screen_share',
  'screenshot_monitor',
  'screenshot',
  'scuba_diving',
  'sd_card_alert',
  'sd_card',
  'sd',
  'sd_storage',
  'search_off',
  'search',
  'security',
  'security_update_good',
  'security_update',
  'security_update_warning',
  'segment',
  'select_all',
  'self_improvement',
  'sell',
  'send_and_archive',
  'send',
  'send_time_extension',
  'send_to_mobile',
  'sensor_door',
  'sensor_occupied',
  'sensor_window',
  'sensors_off',
  'sensors',
  'sentiment_dissatisfied',
  'sentiment_neutral',
  'sentiment_satisfied_alt',
  'sentiment_satisfied',
  'sentiment_very_dissatisfied',
  'sentiment_very_satisfied',
  'set_meal',
  'settings_accessibility',
  'settings_applications',
  'settings_backup_restore',
  'settings_bluetooth',
  'settings_brightness',
  'settings_cell',
  'settings_ethernet',
  'settings_input_antenna',
  'settings_input_component',
  'settings_input_composite',
  'settings_input_hdmi',
  'settings_input_svideo',
  'settings_overscan',
  'settings_phone',
  'settings_power',
  'settings_remote',
  'settings',
  'settings_suggest',
  'settings_system_daydream',
  'settings_voice',
  '7k_plus',
  '7k',
  'severe_cold',
  'shape_line',
  'share_location',
  'share',
  'shield_moon',
  'shield',
  'shop_2',
  'shop',
  'shop_two',
  'shopping_bag',
  'shopping_basket',
  'shopping_cart_checkout',
  'shopping_cart',
  'short_text',
  'shortcut',
  'show_chart',
  'shower',
  'shuffle_on',
  'shuffle',
  'shutter_speed',
  'sick',
  'sign_language',
  'signal_cellular_0_bar',
  // 'signal_cellular_1_bar',
  // 'signal_cellular_2_bar',
  // 'signal_cellular_3_bar',
  'signal_cellular_4_bar',
  'signal_cellular_alt_1_bar',
  'signal_cellular_alt_2_bar',
  'signal_cellular_alt',
  'signal_cellular_connected_no_internet_0_bar',
  // 'signal_cellular_connected_no_internet_1_bar',
  // 'signal_cellular_connected_no_internet_2_bar',
  // 'signal_cellular_connected_no_internet_3_bar',
  'signal_cellular_connected_no_internet_4_bar',
  'signal_cellular_no_sim',
  'signal_cellular_nodata',
  'signal_cellular_null',
  'signal_cellular_off',
  'signal_wifi_0_bar',
  // 'signal_wifi_1_bar_lock',
  // 'signal_wifi_1_bar',
  // 'signal_wifi_2_bar_lock',
  // 'signal_wifi_2_bar',
  // 'signal_wifi_3_bar_lock',
  // 'signal_wifi_3_bar',
  'signal_wifi_4_bar_lock',
  'signal_wifi_4_bar',
  'signal_wifi_bad',
  'signal_wifi_connected_no_internet_4',
  'signal_wifi_off',
  'signal_wifi_statusbar_4_bar',
  'signal_wifi_statusbar_connected_no_internet_4',
  'signal_wifi_statusbar_null',
  'signpost',
  'sim_card_alert',
  'sim_card_download',
  'sim_card',
  'single_bed',
  'sip',
  '6k_plus',
  '6k',
  '60fps',
  '60fps_select',
  'skateboarding',
  'skip_next',
  'skip_previous',
  'sledding',
  'slideshow',
  'slow_motion_video',
  'smart_button',
  'smart_display',
  'smart_screen',
  'smart_toy',
  'smartphone',
  'smoke_free',
  'smoking_rooms',
  'sms_failed',
  'sms',
  'snippet_folder',
  'snooze',
  'snowboarding',
  'snowmobile',
  'snowshoeing',
  'soap',
  'social_distance',
  'solar_power',
  'sort_by_alpha',
  'sort',
  'sos',
  'soup_kitchen',
  'source',
  'south_america',
  'south_east',
  'south',
  'south_west',
  'spa',
  'space_bar',
  'space_dashboard',
  'spatial_audio_off',
  'spatial_audio',
  'spatial_tracking',
  'speaker_group',
  'speaker_notes_off',
  'speaker_notes',
  'speaker_phone',
  'speaker',
  'speed',
  'spellcheck',
  'splitscreen',
  'spoke',
  'sports_bar',
  'sports_baseball',
  'sports_basketball',
  'sports_cricket',
  'sports_esports',
  'sports_football',
  'sports_golf',
  'sports_gymnastics',
  'sports_handball',
  'sports_hockey',
  'sports_kabaddi',
  'sports_martial_arts',
  'sports_mma',
  'sports_motorsports',
  'sports',
  'sports_rugby',
  'sports_score',
  'sports_soccer',
  'sports_tennis',
  'sports_volleyball',
  'square_foot',
  'square',
  'ssid_chart',
  'stacked_bar_chart',
  'stacked_line_chart',
  'stadium',
  'stairs',
  'star_border',
  'star_half',
  'star_outline',
  'star_rate',
  'star',
  'stars',
  'start',
  'stay_current_landscape',
  'stay_current_portrait',
  'stay_primary_landscape',
  'stay_primary_portrait',
  'sticky_note_2',
  'stop_circle',
  'stop',
  'stop_screen_share',
  'storage',
  'store_mall_directory',
  'store',
  'storefront',
  'storm',
  'straight',
  'straighten',
  'stream',
  'streetview',
  'strikethrough_s',
  'stroller',
  'style',
  'subdirectory_arrow_left',
  'subdirectory_arrow_right',
  'subject',
  'subscript',
  'subscriptions',
  'subtitles_off',
  'subtitles',
  'subway',
  'summarize',
  'superscript',
  'supervised_user_circle',
  'supervisor_account',
  'support_agent',
  'support',
  'surfing',
  'surround_sound',
  'swap_calls',
  'swap_horiz',
  'swap_horizontal_circle',
  'swap_vert',
  'swap_vertical_circle',
  'swipe_down_alt',
  'swipe_down',
  'swipe_left_alt',
  'swipe_left',
  'swipe_right_alt',
  'swipe_right',
  'swipe',
  'swipe_up_alt',
  'swipe_up',
  'swipe_vertical',
  'switch_access_shortcut_add',
  'switch_access_shortcut',
  'switch_account',
  'switch_camera',
  'switch_left',
  'switch_right',
  'switch_video',
  'synagogue',
  'sync_alt',
  'sync_disabled',
  'sync_lock',
  'sync_problem',
  'sync',
  'system_security_update_good',
  'system_security_update',
  'system_security_update_warning',
  'system_update_alt',
  'system_update',
  'tab',
  'tab_unselected',
  'table_bar',
  'table_chart',
  'table_restaurant',
  'table_rows',
  'table_view',
  'tablet_android',
  'tablet_mac',
  'tablet',
  'tag_faces',
  'tag',
  'takeout_dining',
  'tap_and_play',
  'tapas',
  'task_alt',
  'task',
  'taxi_alert',
  'temple_buddhist',
  'temple_hindu',
  'terminal',
  'terrain',
  'text_decrease',
  'text_fields',
  'text_format',
  'text_increase',
  'text_rotate_up',
  'text_rotate_vertical',
  'text_rotation_angledown',
  'text_rotation_angleup',
  'text_rotation_down',
  'text_rotation_none',
  'text_snippet',
  'textsms',
  'texture',
  'theater_comedy',
  'theaters',
  'thermostat_auto',
  'thermostat',
  '30fps',
  '30fps_select',
  '3d_rotation',
  '3g_mobiledata',
  '3k_plus',
  '3k',
  '3p',
  '360',
  'thumb_down_alt',
  'thumb_down_off_alt',
  'thumb_down',
  'thumb_up_alt',
  'thumb_up_off_alt',
  'thumb_up',
  'thumbs_up_down',
  'thunderstorm',
  'time_to_leave',
  'timelapse',
  'timeline',
  'timer_10',
  'timer_10_select',
  'timer_3',
  'timer_3_select',
  'timer_off',
  'timer',
  '1x_mobiledata',
  'tips_and_updates',
  'tire_repair',
  'title',
  'toc',
  'today',
  'toggle_off',
  'toggle_on',
  'token',
  'toll',
  'tonality',
  'topic',
  'tornado',
  'touch_app',
  'tour',
  'toys',
  'track_changes',
  'traffic',
  'train',
  'tram',
  'transcribe',
  'transfer_within_a_station',
  'transform',
  'transgender',
  'transit_enterexit',
  'translate',
  'travel_explore',
  'trending_down',
  'trending_flat',
  'trending_up',
  'trip_origin',
  'troubleshoot',
  'try',
  'tsunami',
  'tty',
  'tune',
  'tungsten',
  'turn_left',
  'turn_right',
  'turn_sharp_left',
  'turn_sharp_right',
  'turn_slight_left',
  'turn_slight_right',
  'turned_in_not',
  'turned_in',
  'tv_off',
  'tv',
  '2k_plus',
  '2k',
  'two_wheeler',
  'type_specimen',
  'u_turn_left',
  'u_turn_right',
  'umbrella',
  'unarchive',
  'undo',
  'unfold_less_double',
  'unfold_less',
  'unfold_more_double',
  'unfold_more',
  'unpublished',
  'unsubscribe',
  'upcoming',
  'update_disabled',
  'update',
  'upgrade',
  'upload_file',
  'upload',
  'usb_off',
  'usb',
  'vaccines',
  'vape_free',
  'vaping_rooms',
  'verified',
  'verified_user',
  'vertical_align_bottom',
  'vertical_align_center',
  'vertical_align_top',
  'vertical_shades_closed',
  'vertical_shades',
  'vertical_split',
  'vibration',
  'video_call',
  'video_camera_back',
  'video_camera_front',
  'video_chat',
  'video_file',
  'video_label',
  'video_library',
  'video_settings',
  'video_stable',
  'videocam_off',
  'videocam',
  'videogame_asset_off',
  'videogame_asset',
  'view_agenda',
  'view_array',
  'view_carousel',
  'view_column',
  'view_comfy_alt',
  'view_comfy',
  'view_compact_alt',
  'view_compact',
  'view_cozy',
  'view_day',
  'view_headline',
  'view_in_ar',
  'view_kanban',
  'view_list',
  'view_module',
  'view_quilt',
  'view_sidebar',
  'view_stream',
  'view_timeline',
  'view_week',
  'vignette',
  'villa',
  'visibility_off',
  'visibility',
  'voice_chat',
  'voice_over_off',
  'voicemail',
  'volcano',
  'volume_down',
  'volume_mute',
  'volume_off',
  'volume_up',
  'volunteer_activism',
  'vpn_key_off',
  'vpn_key',
  'vpn_lock',
  'vrpano',
  'wallet',
  'wallpaper',
  'warehouse',
  'warning_amber',
  'warning',
  'wash',
  'watch_later',
  'watch_off',
  'watch',
  'water_damage',
  'water_drop',
  'water',
  'waterfall_chart',
  'waves',
  'waving_hand',
  'wb_auto',
  'wb_cloudy',
  'wb_incandescent',
  'wb_iridescent',
  'wb_shade',
  'wb_sunny',
  'wb_twilight',
  'wc',
  'web_asset_off',
  'web_asset',
  'web',
  'web_stories',
  'webhook',
  'weekend',
  'west',
  'whatshot',
  'wheelchair_pickup',
  'where_to_vote',
  'widgets',
  'width_full',
  'width_normal',
  'width_wide',
  'wifi_1_bar',
  'wifi_2_bar',
  'wifi_calling_3',
  'wifi_calling',
  'wifi_channel',
  'wifi_find',
  'wifi_lock',
  'wifi_off',
  'wifi_password',
  'wifi_protected_setup',
  'wifi',
  'wifi_tethering_error',
  'wifi_tethering_off',
  'wifi_tethering',
  'wind_power',
  'window',
  'wine_bar',
  'woman_2',
  'woman',
  'work_history',
  'work_off',
  'work_outline',
  'work',
  'workspace_premium',
  'workspaces',
  'wrap_text',
  'wrong_location',
  'wysiwyg',
  'yard',
  'youtube_searched_for',
  'zoom_in_map',
  'zoom_in',
  'zoom_out_map',
  'zoom_out',
];

export default muiRoundedIcons;
